<template>
  <div class="portefeuille">
    <div class="sub_menu">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <div v-if="show" style="width: 220px">
            <a-button
              @click="setSpa('s')"
              type="ghost"
              shape="round"
              :style="[
                isActiveSpa('s')
                  ? {
                      backgroundColor: 'teal',
                      color: 'white',
                      borderColor: 'teal',
                    }
                  : {},
              ]"
              style="margin-right: 14px"
            >
              Santé
            </a-button>

            <a-button
              @click="setSpa('p')"
              type="ghost"
              shape="round"
              :style="[
                isActiveSpa('p')
                  ? {
                      backgroundColor: 'brown',
                      color: 'white',
                      borderColor: 'brown',
                    }
                  : {},
              ]"
            >
              Prévoyance
            </a-button>

            <a-button
              v-if="false"
              @click="setSpa('a')"
              type="ghost"
              shape="round"
              :style="[
                isActiveSpa('a')
                  ? {
                      backgroundColor: 'orange',
                      color: 'white',
                      borderColor: 'orange',
                    }
                  : {},
              ]"
            >
              Autres risques
            </a-button>
          </div>
          <!-- Change en cours - resilier -->
          <div v-if="show" style="width: 220px">
            <a-switch
              @change="changeSwitchER($event)"
              v-model:checked="params.spaEr.er.active"
            />
            {{ params.spaEr.er.name }}
          </div>

          <!-- coti page, ind or cot -->
          <div v-if="isCotPage && !isListNoCoti">
            <a-button
              @click="switchCoti('c')"
              type="ghost"
              shape="round"
              :style="[
                isListCotisationCol
                  ? {
                      backgroundColor: 'brown',
                      color: 'white',
                      borderColor: 'brown',
                    }
                  : {},
              ]"
              style="margin-right: 14px"
            >
              Collectives
            </a-button>

            <a-button
              @click="switchCoti('i')"
              type="ghost"
              shape="round"
              :style="[
                isListCotisationInd
                  ? {
                      backgroundColor: 'teal',
                      color: 'white',
                      borderColor: 'teal',
                    }
                  : {},
              ]"
              style="margin-right: 14px"
            >
              Individuelles
            </a-button>
          </div>
          <div v-if="hideSearch">
            <a-input-search
              v-model:value="params.searchValue"
              placeholder="Recherche"
              style="width: 220px"
            />
          </div>
        </div>
      </div>

      <div
        style="
          padding: 8px 20px 12px;
          position: fixed;
          top: 120px;
          left: 60px;
          border-bottom: 1px solid rgb(204, 204, 204);
          right: 0px;
          background-color: rgb(247, 247, 247);
          z-index: 2;
          height: 38px;
        "
      >
        <a-breadcrumb>
          <a-breadcrumb-item>
            Courtier :
            <span @click="showAllHolding()" class="bc_title">
              {{ this.$store.getters.broker.name }}
            </span>
          </a-breadcrumb-item>

          <template v-if="!breadcrumbLoading">
            <a-breadcrumb-item v-if="breadcrumb?.holding?.show">
              Holding :
              <span
                @click="showAllByNumHolding(breadcrumb?.holding, 'he')"
                class="bc_title"
              >
                {{ breadcrumb?.holding?.name }}
              </span>
            </a-breadcrumb-item>

            <a-breadcrumb-item v-if="breadcrumb?.entreprise?.show">
              Entreprise :
              <span
                @click="showAllByNumEntreprise(breadcrumb?.entreprise, 'ec')"
                class="bc_title"
              >
                {{ breadcrumb?.entreprise.name }}
              </span>
            </a-breadcrumb-item>

            <a-breadcrumb-item v-if="breadcrumb?.contract?.show">
              Contrat :
              <span class>{{ breadcrumb?.contract?.name }}</span>
            </a-breadcrumb-item>

            <a-breadcrumb-item>
              {{ listInfo }}
            </a-breadcrumb-item>
          </template>
        </a-breadcrumb>
      </div>
    </div>

    <div id="holdingInfo">
      <h3>{{ holdingInfo.noH }}</h3>
    </div>

    <div class="portefeuille_area">
      <div class="table_pf">
        <HoldingTable
          v-if="tableHolding.show"
          :params="params"
          @show-abnh="showAllByNumHolding"
        />

        <EntrepriseTable
          v-if="tableEntreprise.show"
          :params="params"
          @show-abne="showAllByNumEntreprise"
        />

        <ContratTable
          v-if="tableContrat.show"
          :params="params"
          @show-abnc="showAllByNumContrat"
        />

        <CotisationTableCol
          v-if="tableCotisationCol.show || isListNoCoti"
          :params="params"
        />
        <CotisationTableInd
          v-if="tableCotisationInd.show && !isListNoCoti"
          :params="params"
        />

        <PrestationHoldingTable
          v-if="tableHoldingPrestation.show"
          :params="params"
        />
        <PrestationEntrepriseTable
          v-if="tableEntreprisePrestation.show"
          :params="params"
        />

        <AssureTable v-if="tableAssure.show" />
      </div>
    </div>
  </div>
</template>

<script>
var _ = require("lodash/core");

import HoldingTable from "@/components/HoldingTable.vue";
import EntrepriseTable from "@/components/EntrepriseTable.vue";
import ContratTable from "@/components/ContratTable.vue";
import AssureTable from "@/components/AssureTable.vue";
import CotisationTableCol from "@/components/CotisationTableCol.vue";
import CotisationTableInd from "@/components/CotisationTableInd.vue";
import PrestationHoldingTable from "@/components/PrestationHoldingTable.vue";
import PrestationEntrepriseTable from "@/components/PrestationEntrepriseTable.vue";

export default {
  name: "portefeuille",
  components: {
    HoldingTable,
    EntrepriseTable,
    ContratTable,
    AssureTable,
    CotisationTableCol,
    CotisationTableInd,
    PrestationHoldingTable,
    PrestationEntrepriseTable,
  },
  data: function () {
    return {
      breadcrumbLoading: false,
      breadcrumb: {},

      params: {
        type: "PORTEFEUILLE",
        spaEr: {
          spa: "s",
          er: {
            name: "Contrats en cours",
            status: "e",
            active: true,
          },
        },
        page: 1,
        columnKey: "name",
        order: "ascend",
        searchValue: "",
      },

      pPshow: false,

      showHelp: false,

      holdingInfo: {},

      headerPos: 168,
      headerPosX: 76,

      columnsSaved: false,

      cNames: [],

      notGraphiqueShow: false,

      tableHolding: { show: false },
      tableEntreprise: { show: false },
      tableContrat: { show: false },
      tableAssure: { show: false },
      tableCotisationCol: { show: false },
      tableCotisationInd: { show: false },
      tablePrestation: { show: false },
      tableHoldingPrestation: { show: false },
      tableEntreprisePrestation: { show: false },
    };
  },
  watch: {
    $route(r) {
      this.$store.state.filtreTable = "";
      this.redirect(r.params);
      this.initScroll();

      setTimeout(() => {
        this._breadcrumb();
      }, 100);
    },
  },
  methods: {
    changeSwitchER(e) {
      if (e === true) {
        this.params.spaEr.er.name = "Contrats en cours";
        this.params.spaEr.er.status = "e";
        this.params.spaEr.er.active = true;
      }
      if (e === false) {
        this.params.spaEr.er.name = "Contrats résiliés";
        this.params.spaEr.er.status = "r";
        this.params.spaEr.er.active = false;
      }
    },
    pf(n) {
      return n.replace(/<br>/g, " ");
    },
    _breadcrumb() {
      this.breadcrumbLoading = true;

      this.axios
        .get(`data/breadcrumb/?${new URLSearchParams(this.$route.params)}`)
        .then((r) => {
          if (r.status === 200) {
            this.breadcrumb = r.data;

            setTimeout(() => {
              this.breadcrumbLoading = false;
            }, 100);
          }
        });
    },
    notGraphique() {
      this.notGraphiqueShow = true;
      setTimeout(() => {
        this.notGraphiqueShow = false;
      }, 3000);
    },
    redirect(_) {
      this.tableAssure.show = false;
      this.tableContrat.show = false;
      this.tableEntreprise.show = false;
      this.tableCotisationCol.show = false;
      this.tableCotisationInd.show = false;
      this.tablePrestation.show = false;
      this.tableHoldingPrestation.show = false;
      this.tableEntreprisePrestation.show = false;
      this.tableHolding.show = false;

      if (this.isListHolding) {
        this.tableHolding.show = true;
      }
      if (this.isListEntreprise) this.tableEntreprise.show = true;
      if (this.isListContrat) this.tableContrat.show = true;
      if (this.isListAssure) this.tableAssure.show = true;
      if (this.isListCotisationCol) this.tableCotisationCol.show = true;
      if (this.isListCotisationInd) this.tableCotisationInd.show = true;
      if (this.isListPrestation) this.tablePrestation.show = true;
      if (this.isListHoldingPrestation) this.tableHoldingPrestation.show = true;
      if (this.isListEntreprisePrestation)
        this.tableEntreprisePrestation.show = true;

      this.$store.state.loading = false;
    },
    setSpa(spa) {
      this.params.spaEr.spa = spa;
    },
    switchCoti(coti) {
      this.$router.push({
        name: "portefeuille",
        params: {
          subPage: this.$route.params.subPage.substring(0, 2) + coti,
          numHolding: this.$route.params.numHolding,
          numEntreprise: this.$route.params.numEntreprise,
          numContrat: this.$route.params.numContrat,
        },
      });
    },
    saveColumns() {
      this.$store.dispatch("saveColumns");
      this.columnsSaved = true;
      setTimeout(() => {
        this.columnsSaved = false;
      }, 5000);
    },
    isActiveSpa(spa) {
      return this.params.spaEr.spa == spa ? true : false;
    },
    initScroll() {
      if (window.scrollY >= 10) this.headerPos = 158;
      window.addEventListener(
        "scroll",
        () => {
          let pY = window.scrollY;
          let pX = window.scrollX;
          this.headerPos = 168 - pY;
          this.headerPosX = 76 - pX;
          if (pY >= 10) {
            this.headerPos = 158;
          }
        },
        true
      );
    },
    openHelp() {
      this.showHelp = true;
    },
    exportFromHolding() {
      this.$router.push({ name: "extraction" });
    },
    showAllHolding() {
      this.$router.push({ name: "portefeuille" });
    },

    //Show All
    showAllByNumHolding(holding, subPage) {
      this.breadcrumb.holding.name = holding.name;
      this.breadcrumb.holding.internal_number = holding.internal_number;

      // start first page // don't change params.contractType
      this.params.page = 1;
      this.params.columnKey = "name";
      this.params.order = "ascend";
      this.params.searchValue = "";

      this.$router.push({
        name: "portefeuille",
        params: {
          subPage: subPage,
          numHolding: holding.internal_number,
        },
      });
    },
    showAllByNumEntreprise(entreprise, subPage) {
      this.$router.push({
        name: "portefeuille",
        params: {
          subPage: subPage,
          numHolding: this.numHolding,
          numEntreprise: entreprise.internal_number,
        },
      });
    },
    showAllByNumContrat(contract, subPage) {
      this.$router.push({
        name: "portefeuille",
        params: {
          subPage: subPage,
          numHolding: this.numHolding,
          numEntreprise: contract.company.internal_number,
          numContrat: contract.internal_number,
        },
      });
    },
  },
  computed: {
    show() {
      return ["he", undefined, ""].some((l) => l == this.subPage);
    },
    subPage() {
      return this.$route.params.subPage;
    },
    isCotPage() {
      return this.isListCotisationCol || this.isListCotisationInd
        ? true
        : false;
    },
    isPrestaPage() {
      return this.isListPrestation ? true : false;
    },
    hideSearch() {
      return this.subPage == "ha" ||
        this.subPage == "ea" ||
        this.subPage == "ca" ||
        this.isCotPage ||
        this.isPrestaPage
        ? false
        : true;
    },
    hideParams() {
      return this.subPage == "ha" ||
        this.subPage == "ea" ||
        this.subPage == "ca"
        ? false
        : true;
    },
    showHelpBut() {
      return this.$route.fullPath == "/portefeuille" ? true : false;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    numEntreprise() {
      if (this.isAfterContrat) return undefined;
      return this.$route.params.numEntreprise;
    },
    nomEntreprise() {
      if (this.numEntreprise != undefined) {
        var holding = _.find(this.$store.state.holdings, {
          nuH: this.numHolding,
        });
        return _.find(holding.entreprises, { nuC: this.numEntreprise }).noC;
      }
    },
    numContrat() {
      return this.$route.params.numContrat;
    },
    isListHolding() {
      return this.subPage === undefined || this.subPage === "" ? true : false;
    },
    isListEntreprise() {
      return this.subPage === "he" ? true : false;
    },
    isListContrat() {
      return this.subPage === "hc" || this.subPage === "ec" ? true : false;
    },
    isListAssure() {
      return this.subPage === "ha" ||
        this.subPage === "ea" ||
        this.subPage === "ca"
        ? true
        : false;
    },
    isListCotisationCol() {
      return this.subPage === "htc" ||
        this.subPage === "etc" ||
        this.subPage === "ctc" ||
        this.subPage === "at"
        ? true
        : false;
    },
    isListCotisationInd() {
      return this.subPage === "hti" ||
        this.subPage === "eti" ||
        this.subPage === "cti" ||
        this.subPage === "at"
        ? true
        : false;
    },
    isListPrestation() {
      return this.subPage === "hp" ||
        this.subPage === "ep" ||
        this.subPage === "cp"
        ? true
        : false;
    },
    isListHoldingPrestation() {
      return this.subPage === "hp" ? true : false;
    },
    isListEntreprisePrestation() {
      return this.subPage === "ep" ? true : false;
    },
    isListNoCoti() {
      return this.subPage === "at" ? true : false;
    },
    isAfterContrat() {
      return this.subPage === "ca" ||
        this.subPage === "ct" ||
        this.subPage === "cp"
        ? true
        : false;
    },
    listInfo() {
      if (this.isListNoCoti) return "Cotisations impayées";
      if (this.isListHolding) return "Toutes les holdings";
      if (this.isListEntreprise) return "Toutes les entreprises";
      if (this.isListContrat) return "Tous les contrats";
      if (this.isListAssure) return "Tous les assurés";
      if (this.isListCotisationCol) return "Toutes les cotisations";
      if (this.isListCotisationInd) return "Toutes les cotisations";
      if (this.isListPrestation) return "Toutes les prestations survenues";
    },
    // spa() {
    //   return this.$store.state.spa;
    // },
    // spaColor() {
    //   if (this.spa == "s") return "teal";
    //   if (this.spa == "p") return "brown";
    //   if (this.spa == "a") return "orange";
    // },
    noZeroData: {
      get: function () {
        if (this.isListHolding) return this.$store.getters.noZeroData.h;
        if (this.isListEntreprise) return this.$store.getters.noZeroData.e;
        if (this.isListContrat) return this.$store.getters.noZeroData.c;
        if (this.isListCotisationCol)
          return this.$store.getters.noZeroData.cotiCol;
        if (this.isListCotisationInd)
          return this.$store.getters.noZeroData.cotiInd;
        if (this.isListPrestation) return this.$store.getters.noZeroData.presta;
      },
      set: function (b) {
        if (this.isListHolding) return (this.$store.state.noZeroData.h = b);
        if (this.isListEntreprise) return (this.$store.state.noZeroData.e = b);
        if (this.isListContrat) return (this.$store.state.noZeroData.c = b);
        if (this.isListCotisationCol)
          return (this.$store.state.noZeroData.cotiCol = b);
        if (this.isListCotisationInd)
          return (this.$store.state.noZeroData.cotiInd = b);
        if (this.isListPrestation)
          return (this.$store.state.noZeroData.presta = b);
      },
    },
    headers() {
      if (this.isListHolding) return this.$store.getters.headers.hhp;
      if (this.isListEntreprise) return this.$store.getters.headers.ehp;
      if (this.isListContrat) return this.$store.getters.headers.chp;
      if (this.isListCotisationCol) return this.$store.getters.headers.cotiCol;
      if (this.isListCotisationInd) return this.$store.getters.headers.cotiInd;
      if (this.isListPrestation)
        return this.$store.getters.headers.prestaHolding;
      return [];
    },
  },
  created() {
    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27 && this.showHelp) this.showHelp = false;
    });
  },
  mounted() {
    this.$store.state.filtreTable = "";

    this.redirect(this.$route.params);

    window.scrollTo(0, 0);

    setTimeout(() => {
      document.getElementsByClassName("sub_menu")[0].style.top = "60px";
    }, 10);

    this.initScroll();

    setTimeout(() => {
      this._breadcrumb();
    }, 300);
  },
};
</script>
<style media="screen">
div#not_graphique_popup {
  position: absolute;
  bottom: 66px;
  padding: 10px 20px;
  background: #2a3e4f;
  color: white;
  line-height: 18px;
  border-radius: 10px;
}
.portefeuille_area {
  display: inline-block;
  vertical-align: top;
  padding: 180px 14px 74px 76px;
  width: 100%;
}

.wdt_cp {
  width: 113px !important;
}

td.td_money {
  min-width: 110px !important;
}

span.params_er {
  display: inline-block;
  margin: 0 0 0 16px;
}
.ui.small.breadcrumb {
  position: fixed;
  top: 117px;
  left: 60px;
  border-bottom: 1px solid #ccc;
  right: 0;
  padding: 15px 20px 12px 20px;
  background-color: #f7f7f7;
  z-index: 2;
}
span.bc_title {
  font-weight: bold;
  color: black;
  cursor: pointer;
}
span.bc_title:hover {
  color: darkred;
  transition: 0.3s;
}
div#tableParamsPFShow {
  top: 10px !important;
  right: 50px !important;
  z-index: 3 !important;
}
div#tableParamsPFPopup {
  position: absolute;
  top: 60px;
  right: 17px;
  z-index: 3;
  border: 1px solid #ccc;
  line-height: 19px;
  padding: 4px 10px;
  border-radius: 8px;
  background-color: white;
}

div#tableParamsPFShow .header {
  padding: 5px 30px 7px 0px;
  color: #2b3e50;
  border-bottom: 1px solid #2b3e50;
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
}
#tableParamsPFShow:before {
  top: 6% !important;
}
.filtre_table {
  position: absolute;
  display: inline-block;
  margin: 0 60px;
}

div#graphic_area {
  position: fixed;
  height: 60px;
  background-color: #2a3e50;
  bottom: -60px;
  line-height: 60px;
  width: 700px;
  left: 50%;
  margin-left: -350px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: 0.6s;
}
div#ga_links {
  display: inline-block;
  margin: 0 0 0 30px;
}
.ga_links_g {
  color: white;
  cursor: pointer;
  width: 190px;
  display: inline-block;
}
.ga_links_g:hover {
  color: orange;
}
.ga_links_c {
  color: white;
  /* display: inline-block; */
  width: 190px;
  line-height: 1.4;
  float: right;
  margin: 12px 0 0 60px;
  border-left: 1px solid #fff;
  padding-left: 50px;
}

div#holdingInfo {
  position: fixed;
  z-index: 3;
  right: -400px;
  top: 62px;
  width: 400px;
  background-color: #253e52a3;
  bottom: 0;
  color: white;
  transition: 0.5s;
}

/* tables */
div#holdingTable,
div#entrepriseTable,
div#contratTable,
div#cotisationTable {
  position: fixed;
  border: 1px solid #ccc;
  background-color: white;
  text-align: right;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin-bottom: 12px;
  top: 158px;
  left: 76px;
  border-bottom: 1px solid #ccc;
  right: 14px;
  z-index: 1;
}
div#holdingTable div,
div#entrepriseTable div,
div#contratTable div,
div#cotisationTable div {
  line-height: inherit !important;
}

div#holdingTable span,
div#entrepriseTable span,
div#contratTable span,
div#cotisationTable span {
  cursor: pointer;
}

.pTop8 {
  padding-top: 4px !important;
}
.pTop16 {
  padding-top: 16px !important;
}

.sort_icon i {
  position: absolute;
}

.tr {
  width: 100%;
  border: 1px solid #ccc;
  background-color: white;
  margin-bottom: 4px;
  text-align: right;
}

.td {
  height: 50px;
  padding: 0 6px;
  display: inline-block;
  margin: 0 4px;
  vertical-align: top;
  line-height: 50px;
  white-space: nowrap;
}
.td_checkBox {
  width: 20px;
  text-align: center;
  float: left;
  line-height: inherit;
  padding-top: 7px;
}
.td_name {
  width: 280px;
  float: left;
  text-align: left;
  line-height: inherit;
  padding-top: 7px;
  overflow: hidden;
}
.td_number {
  width: 100px;
  text-align: center;
}
.td_college {
  width: 150px;
  text-align: center;
}
.td_categorie {
  width: 150px;
  text-align: center;
}
.td_assureur {
  width: 280px;
  text-align: center;
}

.td_cotpre {
  width: 120px;
  line-height: inherit;
  padding-top: 4px;
  text-align: center;
  letter-spacing: -0.9px;
}
.td_pre_hol {
  width: 150px;
  line-height: inherit;
  padding-top: 3px;
  text-align: right;
}
.td_date {
  width: 130px;
  text-align: center;
}
.td_doc {
  width: 94px;
  text-align: center;
}
.td i {
  margin: 0 !important;
}
.for_float {
  height: 50px;
  padding: 0;
  display: inline-block;
  margin: 0;
  vertical-align: top;
  line-height: 50px;
}
.hover:hover {
  cursor: pointer;
}

.no_result {
  font-size: 30px;
  color: #ccc;
  text-align: center;
}

.col_save_text {
  position: absolute;
  right: 8px;
  bottom: 17px;
  color: green;
}

/* HELP */
div#pageHelp {
  position: fixed;
  background-color: #000000ba;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
}

div#helpCont {
  position: fixed;
  width: 1180px;
  top: 400px;
  left: 50%;
  margin-left: -590px;
}

img#holdingHelp {
  width: 1180px;
}

.help_text {
  color: white;
  font-size: 1.2em;
  position: absolute;
}

div#h_1 {
  left: 739px;
  top: 100px;
}
div#h_2 {
  left: 850px;
  top: 72px;
}
div#h_3 {
  left: 739px;
  top: -60px;
}
div#h_4 {
  left: 850px;
  top: -32px;
}

.help_icon {
  font-size: 1em;
  color: white;
  position: absolute;
}

i#i_1 {
  top: 75px;
  left: 716px;
  transform: rotate(-29deg);
}
i#i_2 {
  top: 63px;
  left: 825px;
  transform: rotate(-50deg);
}
i#i_3 {
  top: -29px;
  left: 716px;
  transform: rotate(-150deg);
}
i#i_4 {
  top: -20px;
  left: 823px;
  transform: rotate(-132deg);
}
</style>
